import styled from 'styled-components';

import { Vertical } from '#src/atoms/layout/flex/index.tsx';
import { Scrollable } from '#src/atoms/navigation/Scrollable/index.tsx';
import { useIsLaptop } from '#src/hooks/device/useIsLaptop.ts';

const LaptopWrapper = styled(Vertical)`
  align-items: stretch;
  overflow-x: auto;
  overflow-y: hidden;
  gap: var(--half-unit);
`;

export const ResponsiveRaritiesWrapper = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const isLaptop = useIsLaptop();

  if (isLaptop) {
    return <LaptopWrapper>{children}</LaptopWrapper>;
  }
  // use a scrollable container for mobile
  return (
    <Scrollable itemToDisplay={4} overhang contained withScrollButtons={false}>
      {children}
    </Scrollable>
  );
};
